import type { DiscountType } from '../enums/DiscountType'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { CategoryMiniEntity } from '@/features/category/domain/entities/CategoryMiniEntity'
import type { ItemMiniEntity } from '@/features/item/domain/entities/ItemMiniEntity'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { UserGroupEntity } from '@/features/userGroup/domain/entities/UserGroupEntity'
import type { DiscountSpecifiedItemCategoryEntity } from './DiscountSpecifiedItemCategoryEntity'

export class CreateDiscountOfferEntity {
  name?: string | null
  type?: DiscountType
  value?: number
  maxDiscountAllowed?: number
  minCartAmount?: number | null
  start?: Date
  end?: Date
  firstPurchase?: boolean | null
  users?: Array<UserMiniEntity> | null
  groups?: Array<UserGroupEntity> | null
  categories?: Array<CategoryMiniEntity> | null
  items?: Array<ItemMiniEntity> | null
  serviceRatio?: number
  branchRatio?: number
  priority?: number | null 
  branch?:BranchMiniEntity
  isActive?: boolean;
  specifiedItemsCategories?: Array<DiscountSpecifiedItemCategoryEntity> | null
}
